import { useState } from "react";
import { useTranslation } from "react-i18next";
import PlagiarismOutlinedIcon from "@mui/icons-material/PlagiarismOutlined";
import { MenuItem } from "@mui/material";

import Modal, { ModalSize } from "~/common/components/Modal";
import { LinkButton } from "~/common/components/Link";
import { Button } from "~/common/components/Button/Button";
import { Stacker } from "~/common/components/Stacker/Stacker";
import classes from "./ChoosePriceReferenceForCart.module.less";
import { useBooleanState } from "../../../../common/hooks/useBooleanState";
import PriceReferenceDropdown from "../../../../ProductDetails/components/AddToCartCard/PriceReferenceDropdown";
import { userCanSeeEndCustomer } from "../../CartPage/LineItemStaticParams";
import { userIsDistributor, userIsPurchaser } from "../../../../utils/roles";

interface Props {
  className?: string;
  updatePriceReference: (priceReference: string) => void;
  menuClassName?: string;
  isB2BCart?: boolean;
}

export const ChoosePriceReferenceForCart = ({
  className,
  menuClassName,
  isB2BCart = false,
  updatePriceReference,
}: Props) => {
  const { t } = useTranslation();

  const { val: modalOpen, setTrue: open, setFalse: close } = useBooleanState(false);
  const [priceReference, setPriceReferece] = useState("");

  if (!window.SCHA.feature.showChoosePriceRefForCartButton) {
    return null;
  }

  if (userCanSeeEndCustomer()) {
    return null;
  }

  const isDistributorOrPurchaser =
    (userIsDistributor() || userIsPurchaser()) && window.SCHA.config.priceReferences.length >= 2;
  if (!isDistributorOrPurchaser) {
    return null;
  }

  const onSave = () => {
    close();
    updatePriceReference(priceReference);
  };

  const choosePriceReferenceBtn = (
    <LinkButton
      iconBefore={<PlagiarismOutlinedIcon className={classes.iconButton} />}
      onClick={() => open()}
      data-test-id={"btn-load-all-pna"}
      className={className}
    >
      {t(isB2BCart ? "cartPage.btn.choosePriceReferenceForCart" : "cartPage.bulkUpload.btn.selectPriceReferenceForAll")}
    </LinkButton>
  );

  return (
    <>
      {isB2BCart ? <MenuItem className={menuClassName}>{choosePriceReferenceBtn}</MenuItem> : choosePriceReferenceBtn}

      {modalOpen && (
        <Modal
          size={ModalSize.SMALL}
          onClose={close}
          hideClose={true}
          title={t(
            isB2BCart
              ? "cartPage.modal.choosePriceReferenceForCart.title"
              : "cartPage.modal.choosePriceReferenceForBulkEntry.title",
          )}
          footerChildren={
            <Stacker gap={8} direction={"row"}>
              <Button variant={"text"} onClick={close}>
                {t("cancel")}
              </Button>
              <Button color="primary" onClick={onSave}>
                {t("text.company.save.button")}
              </Button>
            </Stacker>
          }
        >
          <PriceReferenceDropdown
            hideLabel={true}
            selected={priceReference}
            onChange={(val) => setPriceReferece(val as string)}
          />
        </Modal>
      )}
    </>
  );
};
